import linkedin from "../../static/images/linkedin.png";
import discord from "../../static/images/discord.png";
import githubDark from "../../static/images/github.png";

export default function ContactFields() {
  return (
    <div className="Contact-card">
      <div className="Contact-card-icons">
        <div className="Contact-card-icon">
          <a
            href="https://www.linkedin.com/in/zachary-foteff/"
            target="_blank"
            rel="noreferrer"
          >
            <img className="Contact-card-icon" src={linkedin} alt="linkedin" />
          </a>
        </div>
        <div className="Contact-card-icon">
          <a
            href="https://www.discordapp.com/users/204805762105475072"
            target="_blank"
            rel="noreferrer"
          >
            <img className="Contact-card-icon" src={discord} alt="discord" />
          </a>
        </div>
        <div className="Contact-card-icon">
          <a
            href="https://www.github.com/zfoteff"
            target="_blank"
            rel="noreferrer"
          >
            <img className="Contact-card-icon" src={githubDark} alt="github" />
          </a>
        </div>
      </div>
      <div className="Contact-card-message-area">
        <p>
          Email me at <b>zfoteff@protonmail.com</b>, or use the field below to
          send me a short message
        </p>
        <form>
          <input
            id="mailback-address"
            name="mailback-address"
            type="email"
            placeholder="Return Address"
          />
          <input
            id="subject"
            name="subject"
            type="text"
            placeholder="Subject"
          />
          <textarea id="message" name="message" placeholder="Message" />
          <button id="submit" type="submit">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}
